export default __webpack_public_path__ + "static/media/FinanceRealCase.6bc5f03e.png";